// @flow

type FlashMessage = string | Array<string>;

type FlashManager = {
  remove: (selector: ?string) => void,
  fadeOut: () => void,
  fadeOutAfterDelay: () => void,
  fadeIn: () => void,
  setNotice: (message: FlashMessage) => void,
  setError: (message: FlashMessage) => void,
  setDefaultError: () => void,
  setPending: (message: FlashMessage, fade?: boolean) => void,
  setDefaultPending: () => void,
  set: (message: FlashMessage, type: string, fadeOut: boolean) => void,
};

// while "{}" is not a FlashManager this is only an issue in testing
const Flash: FlashManager = window && window.Flash ? window.Flash : {};
module.exports = Flash;
